import React from 'react';
import {tableActionEvent} from "../../../../services/query_builder_events";
import PIPELINE_STEPS from "../../../../utils/pipeline_steps";

export default function TableMenu({step}) {
    return (
        <div className="pipeline-step-result-table-actions">
            <div onClick={() => tableActionEvent.emit(PIPELINE_STEPS.ADD_COLUMN, {parent: step})}>
                <img src="images/table-actions/add column.svg" alt="" /><span>Calculated Column</span>
            </div>
            <div className="unavailable"><img src="images/table-actions/reorder.svg" alt="" /><span>Reorder</span></div>
            <div className="unavailable"><img src="images/table-actions/limit.svg" alt="" /><span>Limit rows</span></div>
            <div className="unavailable"><img src="images/table-actions/pivot.svg" alt="" /><span>Pivot</span></div>
            <div className="unavailable"><img src="images/table-actions/transpose.svg" alt="" /><span>Transpose</span></div>
            <div className="unavailable"><img src="images/table-actions/unpivot.svg" alt="" /><span>Unpivot</span></div>
            <div className="unavailable"><img src="images/table-actions/zero fill.svg" alt="" /><span>Zero Fill</span></div>
            <div className="unavailable"><img src="images/table-actions/combine.svg" alt="" /><span>Combine</span></div>
            <div className="unavailable"><img src="images/table-actions/filter.svg" alt="" /><span>Filter</span></div>
            <div className="unavailable"><img src="images/table-actions/group.svg" alt="" /><span>Group</span></div>
        </div>
    );
}